import FetchService from "@core-ui/ApiServices/FetchService";
import type Url from "@core-ui/ApiServices/Types/Url";
import { resolveFileKind } from "@core-ui/utils/resolveFileKind";

const fetchLogoImage = async (url: Url): Promise<Blob | null> => {
	const res = await FetchService.fetchInBackground(url);
	if (!res.ok) return null;

	const buffer = await res.buffer();
	if (!buffer?.length) return null;
	return new Blob([buffer], { type: resolveFileKind(buffer) });
};

export default fetchLogoImage;
